/* ── SmartPack Core — predictive search ──────────────────────────────────────
   Fetches the dropdown as a section so the markup stays in Liquid. limit_scope
   is 'each', otherwise ten results are shared across every type and industries
   take slots away from products.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  var ENDPOINT = '/search/suggest';
  var EXCLUDE = ' -tag:hideme';
  var PARAMS = 'resources[type]=product,collection,page,query'
    + '&resources[limit]=10&resources[limit_scope]=each'
    + '&resources[options][unavailable_products]=last'
    + '&section_id=sp-predictive-search';

  function init(form) {
    if (!form || form.dataset.spPsReady) return;
    form.dataset.spPsReady = '1';

    var input = form.querySelector('input[type="search"], input[name="q"]');
    var host = form.closest('[data-sp-ps-host]') || form.parentNode;
    if (!input || !host) return;

    var panel = null, timer = null, controller = null, term = '', scrim = null;

    /* Both the panel and the scrim fade out before they leave the DOM. A plain
       timeout backs up transitionend, which never fires under reduced motion. */
    function retire(el) {
      el.classList.remove('is-open');
      var gone = function () { el.remove(); };
      el.addEventListener('transitionend', gone, { once: true });
      setTimeout(gone, 500);
    }

    function reveal(el, instant) {
      if (!instant) void el.offsetHeight;
      el.classList.add('is-open');
    }

    /* Scrim */
    function dim(on) {
      if (on) {
        if (scrim) return;
        scrim = document.createElement('div');
        scrim.className = 'sp-ps-scrim';
        document.body.appendChild(scrim);
        scrim.addEventListener('click', close);
        reveal(scrim);
      } else if (scrim) {
        retire(scrim);
        scrim = null;
      }
    }

    function close() {
      if (panel) { retire(panel); panel = null; }
      dim(false);
      input.setAttribute('aria-expanded', 'false');
    }

    function items() {
      return panel ? Array.prototype.slice.call(panel.querySelectorAll('[data-sp-ps-item]')) : [];
    }

    function move(dir) {
      var list = items();
      if (!list.length) return;
      var i = list.indexOf(document.activeElement);
      i = i < 0 ? (dir > 0 ? 0 : list.length - 1) : i + dir;
      if (i < 0) { input.focus(); return; }
      if (i >= list.length) i = 0;
      list[i].focus();
    }

    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-sp-ps-panel]');
      if (!next) { close(); return; }
      var styles = doc.querySelectorAll('style');
      var swapping = !!panel;
      if (panel) panel.remove();
      panel = next;
      if (styles.length && !document.getElementById('sp-ps-style')) {
        var st = document.createElement('style');
        st.id = 'sp-ps-style';
        st.textContent = Array.prototype.map.call(styles, function (s) { return s.textContent; }).join('\n');
        document.head.appendChild(st);
      }
      host.appendChild(panel);
      reveal(panel, swapping);
      dim(true);
      input.setAttribute('aria-expanded', 'true');
    }

    function fetchTerm(q) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = ENDPOINT + '?q=' + encodeURIComponent(q) + '&' + PARAMS;
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(render)
        .catch(function () { });
    }

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-expanded', 'false');

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === term) return;
      term = q;
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () { fetchTerm(q); }, 180);
    });

    input.addEventListener('focus', function () {
      if (!panel && input.value.trim().length >= 2) fetchTerm(input.value.trim());
    });

    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q || q.indexOf(EXCLUDE.trim()) > -1) return;
      e.preventDefault();
      window.location.href = form.getAttribute('action') + '?q=' + encodeURIComponent(q + EXCLUDE);
    });

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
    });

    document.addEventListener('click', function (e) {
      if (!panel) return;
      if (!host.contains(e.target)) close();
    });

    document.addEventListener('focusin', function (e) {
      if (!panel) return;
      if (!host.contains(e.target)) close();
    });
  }

  function boot() {
    document.querySelectorAll('[data-sp-ps-form]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
